export default __webpack_public_path__ + "static/media/SD-ekantha-seva-img.4265adf2.png";